<div class="customer-credit-memo">
  <div class="content" (scroll)="onScroll($event)">
    <div class="ui-g-12 mt-2 justify-content-end p-zero">
      <div class="my-3 ui-g-5 float-right p-0">
        <button class="btn btn-block btn-side-list" (click)="openCreditMemoModal()">
          <i class="fal fa-plus pr-6p"></i>
          Credit memo
        </button>
      </div>
    </div>
    <div class="ui-g-12 credit-memo-card p-0">
      <p-table class="customers-credit-memo-list" #dt sortField="fullNameQBO" [columns]="cols" [customSort]="true" [value]="creditMemo" [lazy]="true" [scrollable]="true" [sortOrder]="1">
        <ng-template pTemplate="header" let-columns>
          <tr class="customer-grid-row-header">
            <th class="memoId">Credit memo ID</th>
            <th class="status">Status</th>
            <th *ngIf="isQboConnected" class="status">QBO status</th>
            <th class="amount">Amount</th>
            <th class="rem-amount">Remaining amount</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-rowData let-rowIndex="rowIndex" let-columns="columns">
          <tr *ngIf="!loading && creditMemo.length > 0">
            <td *ngFor="let col of columns" [ngClass]="col.class">
              <span *ngIf="col.field === 'code'" class="pointer open-link-container d-flex" (click)="openCreditMemoModal(rowData)">
                <div class="truncate-inline hover-underline pointer text-truncate">
                  <span>
                    {{ rowData[col.field] }}
                  </span>
                </div>
                <div>
                  <i class="open-link-icon pl-2 fal fa-external-link-alt pointer"></i>
                </div>
              </span>
              <span *ngIf="col.field === 'status'">
                {{ rowData[col.field] }}
              </span>
              <span *ngIf="col.field === 'qboSyncStatus'">
                {{ rowData[col.field] === true ? 'Synced' : 'Unsynced' }}
              </span>
              <span *ngIf="col.field === 'amount' || col.field === 'remainingAmount'">
                {{ rowData[col.field] || 0 | currency : usd }}
              </span>
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
    <div class="ui-g-12 credit-memo-card flex-between-center">
      <div class="font-secondary-900 font-600 font-14">Total available credit</div>
      <div class="font-secondary-900 font-600 font-14">{{ totalAvailableCredit || 0 | currency : usd }}</div>
    </div>
  </div>
</div>
